module.exports = __webpack_public_path__ + "static/media/Keeper.e619df6c.gif";